import { IBaseList } from "./base-list";
import { IDire } from "./dire";
import { IReceiver } from './receiver';

/**
 * Interface representing receivers list
 */
export interface IReceiverList extends IBaseList {
  items: IReceiver[];
};

export let emptyReceiverList: IReceiverList = {
  page: 1,
  limit: 1000,
  count: 0,
  total: 0,
  items: []
};


// WEBPACK FOOTER //
// ./src/app/model/receiver-list.ts